import createAPI from '../axios'

// 资源申请相关 API
const resource = {
    // 资源申请
    apply: {
        list: config => createAPI('/resource/apply/list', 'post', config),
        info: config => createAPI('/resource/apply/info', 'post', config),
        submit: config => createAPI('/resource/apply/submit', 'post', config),
        getClass: config => createAPI('/resource/apply/getClass', 'post', config),
        save: config => createAPI('/resource/apply/save', 'post', config),
        getRole: config => createAPI('/resource/apply/getRole', 'post', config),
        delete: config => createAPI('/resource/apply/del', 'delete', config),
    },
    process:{
        approval:config => createAPI('/resource/process/approval', 'post', config),
    }
};

export default resource;



// WEBPACK FOOTER //
// ./src/api/modules/resource.js